import { faCommentDots, faGift, faHeart, faPlusCircle, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MDBBtn, MDBCard, MDBCarousel, MDBCarouselItem, MDBCol, MDBContainer, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBRow } from 'mdb-react-ui-kit';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import Download from '../component/download';
import LightBox from '../component/lightbox';
import Loading from '../component/loading';
import Nav from '../component/nav';
import Toast from '../component/toast';
import request from '../util/client';
import Review, { ReviewModal } from './Review';

export default function Note() {
  const [data, setData] = React.useState({});
  const [gold, setGold] = React.useState(0);
  const [showGift, setShowGift] = React.useState(false);
  const params = useParams();
  const loading = React.useRef();
  const lightbox = React.useRef();
  const toast = React.useRef();
  const onClick = React.useRef((index, data, e) => {
    e.stopPropagation();
    e.preventDefault();
    lightbox.current.show(
      data.videoUrl ? data.videoUrl : data.imgUrls[index],
      data.videoUrl ? 1 : 0
    );
  });
  const onReview = React.useRef((noteId, e) => {
    e.stopPropagation();
    e.preventDefault();
    let ev = new Event('review');
    ev.data = {
      noteId, callback: () => {
        let b = e.target;
        while (b.tagName !== 'BUTTON') {
          b = b.parentElement;
        }
        let v = b.querySelector('span');
        v.innerText = parseInt(v.innerText) + 1;
        window.document.dispatchEvent(new Event('reloadreview'));
      }
    };
    window.document.dispatchEvent(ev);
  });
  const onLike = React.useRef((noteId, e) => {
    e.stopPropagation();
    e.preventDefault();
    let b = e.target;
    while (b.tagName !== 'BUTTON') {
      b = b.parentElement;
    }
    let type, v = b.querySelector('span');
    if (b.classList.contains('active')) {
      type = '0';
      b.classList.remove('active');
      v.innerText = parseInt(v.innerText) - 1;
    } else {
      type = '1';
      b.classList.add('active');
      v.innerText = parseInt(v.innerText) + 1;
    }
    request('index/note/like', 'POST', { noteId, type });
  });
  const onCollect = React.useRef((noteId, e) => {
    e.stopPropagation();
    e.preventDefault();
    let b = e.target;
    while (b.tagName !== 'BUTTON') {
      b = b.parentElement;
    }
    let type, v = b.querySelector('span');
    if (b.classList.contains('active')) {
      type = '0';
      b.classList.remove('active');
      v.innerText = parseInt(v.innerText) - 1;
    } else {
      type = '1';
      b.classList.add('active');
      v.innerText = parseInt(v.innerText) + 1;
    }
    request('index/note/collect', 'POST', { noteId, type });
  });
  const onFollow = React.useRef((memberId, e) => {
    e.stopPropagation();
    e.preventDefault();
    let b = e.target;
    while (b.tagName !== 'BUTTON') {
      b = b.parentElement;
    }
    b.remove();
    request('member/follow', 'POST', { memberId, type: 1 }).then(() => {
      toast.current.show('关注成功', 'success');
    });
  });
  const onGift = React.useRef(e => {
    e.stopPropagation();
    e.preventDefault();
    let data = new window.FormData(e.target);
    let params = {};
    for (const [k, v] of data.entries()) {
      params[k] = v;
    }
    setShowGift(false);
    if (params['amount'] <= 0) {
      return;
    }
    request('index/note/reward', 'POST', params).then(() => {
      toast.current.show('打赏成功', 'success');
    });
  });
  React.useEffect(() => {
    if (showGift) {
      request('wallet/myWalletMyWallet', 'POST').then(response => {
        setGold(parseFloat(response.data.exp));
      });
    }
  }, [showGift]);
  React.useEffect(() => {
    if (!params.note) {
      return;
    }
    loading.current.show();
    request('index/note/detail', 'POST', { noteId: params.note }).then(response => {
      setData(response.data);
      loading.current.hide();
    });
  }, [params.note]);
  return (
    <>
      <Helmet>
        <title>{data.title ? data.title + ' - ' : ''}Linky</title>
      </Helmet>
      <Nav />
      {data.noteId ? (
        <MDBContainer className="note-detail">
          <MDBRow>
            <MDBCol size="12" lg="8" xl="9" className="mb-3">
              <MDBCard className="note-info">
                {data.videoUrl ? (
                  <video src={data.videoUrl} controls={true} autoPlay={true}></video>
                ) : (
                  <MDBCarousel showIndicators touch={true} fade={window.matchMedia('(prefers-reduced-motion)').matches}>
                    {data.imgUrls.map((url, index) => (
                      <MDBCarouselItem
                        key={url}
                        src={url}
                        itemId={index + 1}
                        alt=""
                        onClick={onClick.current.bind(null, index, data)}
                      />
                    ))}
                  </MDBCarousel>
                )}
                <h3 className="title">{data.title}</h3>
                {data.content ? (<p className="content">{data.content}</p>) : null}
                <div className="more">
                  {data.topicName ? (<p className="topic">#{data.topicName}</p>) : null}
                  {data.date ? (<p className="date">发布于：{data.date}</p>) : null}
                </div>
              </MDBCard>
            </MDBCol>
            <MDBCol size="12" lg="4" xl="3" className="mb-3">
              <MDBCard className="author">
                <span className="avatar">
                  <span className="img">
                    <img src={data.avatarUrl} width="48" height="48" alt="" />
                  </span>
                  {parseInt(data.isShowFollow) && !parseInt(data.isFollowMember) ? (
                    <MDBBtn color="link" className="btn-follow" onClick={onFollow.current.bind(null, data.memberId)}>
                      <FontAwesomeIcon icon={faPlusCircle} />
                    </MDBBtn>
                  ) : null}
                </span>
                <span className="nickname">{data.nickname}</span>
                <div className="tools">
                  <MDBBtn color="link" className={parseInt(data.isCollectNote) ? 'active' : ''} onClick={onCollect.current.bind(null, data.noteId)}>
                    <FontAwesomeIcon icon={faHeart} />
                    <span>{parseInt(data.collects) || 0}</span>
                  </MDBBtn>
                  <MDBBtn color="link" className={parseInt(data.isLikeNote) ? 'active' : ''} onClick={onLike.current.bind(null, data.noteId)}>
                    <FontAwesomeIcon icon={faThumbsUp} />
                    <span>{parseInt(data.likes) || 0}</span>
                  </MDBBtn>
                  <MDBBtn color="link" onClick={onReview.current.bind(null, data.noteId)}>
                    <FontAwesomeIcon icon={faCommentDots} />
                    <span>{parseInt(data.reviews) || 0}</span>
                  </MDBBtn>
                  <MDBBtn color="link" className="active" onClick={() => setShowGift(true)}>
                    <FontAwesomeIcon icon={faGift} />
                  </MDBBtn>
                </div>
              </MDBCard>
            </MDBCol>
            <MDBCol size="12">
              <Review note={data.noteId} />
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      ) : null}
      <ReviewModal />
      <MDBModal show={showGift} setShow={setShowGift} tabIndex='-1'>
        <MDBModalDialog centered>
          <MDBModalContent tag="form" onSubmit={onGift.current}>
            <MDBModalHeader>
              <MDBModalTitle>打赏</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={() => setShowGift(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <h6>当前金币剩余: {gold}</h6>
              <input type="hidden" name="noteId" value={data.noteId} />
              <input type="number" name="amount" className="form-control" min="0" max={gold} placeholder="请输入打赏金额" />
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn type="submit">确认打赏</MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
      <Download />
      <LightBox ref={lightbox} />
      <Loading ref={loading} />
      <Toast ref={toast} />
    </>
  );
}
